// In-Room Live Chat & Reaction Gift System
import { sounds } from './sound.js';

export class ChatManager {
  constructor(socket, chatContainer, inputEl, sendBtn, reactionBarEl) {
    this.socket = socket;
    this.chatContainer = chatContainer;
    this.inputEl = inputEl;
    this.sendBtn = sendBtn;
    this.reactionBarEl = reactionBarEl;

    this.setupListeners();
  }

  updateSocket(newSocket) {
    this.socket = newSocket;
  }

  setupListeners() {
    this.sendBtn?.addEventListener('click', () => this.sendMessage());
    this.inputEl?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') this.sendMessage();
    });

    // Reaction Gifts (Tomato 🍅, Confetti 🎉, Bomb 💣, Beer 🍻, Crown 👑)
    if (this.reactionBarEl) {
      this.reactionBarEl.querySelectorAll('.reaction-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const emoji = btn.dataset.emoji;
          if (this.socket?.emit) {
            this.socket.emit('sendReaction', { emoji });
            this.socket.emit('sendReactionGift', { emoji });
          }
          this.triggerLocalReaction(emoji);
        });
      });
    }
  }

  sendMessage() {
    const text = this.inputEl?.value?.trim();
    if (!text) return;
    if (this.socket?.emit) {
      this.socket.emit('sendChatMessage', { text });
    }
    this.inputEl.value = '';
  }

  appendMessage(msg) {
    if (!this.chatContainer) return;
    const item = document.createElement('div');
    item.className = 'chat-bubble';
    item.innerHTML = `
      <span class="chat-avatar">${msg.senderAvatar || '👤'}</span>
      <div class="chat-content">
        <span class="chat-author" style="color: ${msg.senderColor || '#38bdf8'};">${msg.senderName}:</span>
        <span class="chat-text">${this.escapeHtml(msg.text)}</span>
      </div>
    `;
    this.chatContainer.appendChild(item);
    this.chatContainer.scrollTop = this.chatContainer.scrollHeight;
    sounds.playPop();
  }

  triggerLocalReaction(emoji) {
    sounds.playPop();
    const layer = document.getElementById('reactions-layer') || document.body;
    for (let i = 0; i < 6; i++) {
      const el = document.createElement('div');
      el.className = 'floating-reaction';
      el.innerText = emoji;
      el.style.left = `${30 + Math.random() * 40}%`;
      el.style.bottom = '100px';
      el.style.transform = `scale(${0.8 + Math.random() * 0.8})`;
      layer.appendChild(el);

      setTimeout(() => el.remove(), 2000);
    }
  }

  escapeHtml(str) {
    return str.replace(/[&<>'"]/g, (tag) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    }[tag] || tag));
  }
}
